import React, { useState, useEffect, useMemo, useCallback } from "react";
import "../../assets/css/LicenseManagement.css";
import { CommonDialogV2 } from "../common/CommonComponents/Dialog";
import { DialogActions, InputAdornment } from "@material-ui/core";
import axios from "axios";
import GenWiz from "../common/Popups/Genwizui";
import { CSVLink } from "react-csv";
import {
  StyledSearchBarPlatforms,
  StyledSearchIcon,
} from "../fui/FuiStyles";

const LicenseManagement = () => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState(null);
  const [isSendMailVisible, setSendMailVisible] = useState(false);
  const [isEditVisible, setEditVisible] = useState(false);
  const [isDeleteVisible, setDeleteVisible] = useState(false);
  const [licenseData, setLicenseData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;
  const [sortByCustomerNameAsc, setSortByCustomerNameAsc] = useState(true);
  const [sortByLicensePoCasc, setSortByLicensePoCasc] = useState(true);
  const [sortByCapacityAsc, setSortByCapacityAsc] = useState(true);
  const [currentSortField, setCurrentSortField] = useState('customer_name');
  const [isloading, setisloading] = useState(false);
  const [gwconfig, setgenwiz] = useState({ stateFunction: setgenwiz });
  const [additionalCc, setAdditionalCc] = useState("");
  const [orderId, setOrderId] = useState("");
  const [isCancelVisible, setCancelVisible] = useState(false);
  const [cancelStatus, setCancelStatus] = useState("");
  const [editFields, setEditFields] = useState({
    customer_name: "",
    sap_contract_id: "",
    tenant_type: "",
    user_email: "",
    wbse_code: ""
  });

  // Calculate license usage statistics
  const licenseStats = useMemo(() => {
    const activeLicenses = licenseData.filter(license => 
      license.status && license.status.toLowerCase() === 'active'
    );
    
    const inactiveLicenses = licenseData.filter(license => {
      const status = license.status.toLowerCase();
      return status === 'inactive' || status === 'deactive';
    });

    // Count ACTIVE licenses without WBSE or Contract ID
    const activeLicensesWithoutWBSE = licenseData.filter(license => 
      license.status && 
      license.status.toLowerCase() === 'active' &&
      (!license.wbse_code || license.wbse_code.trim() === '')
    );

    const activeLicensesWithoutContractID = licenseData.filter(license => 
      license.status && 
      license.status.toLowerCase() === 'active' &&
      (!license.sap_contract_id || license.sap_contract_id.trim() === '')
    );

    // Count licenses with notes
    const licensesWithNotes = licenseData.filter(license => 
      license.notes && license.notes.trim() !== ''
    );

    const totalCapacityActive = activeLicenses.reduce((total, license) => 
      total + (parseInt(license.licence_capacity_gb) || 0), 0
    );

    const totalCapacityAll = licenseData.reduce((total, license) => 
      total + (parseInt(license.licence_capacity_gb) || 0), 0
    );

    return {
      totalLicenses: licenseData.length,
      activeLicenses: activeLicenses.length,
      inactiveLicenses: inactiveLicenses.length,
      totalCapacityActive,
      totalCapacityAll,
      activePercentage: licenseData.length > 0 ? Math.round((activeLicenses.length / licenseData.length) * 100) : 0,
      activeLicensesWithoutWBSE: activeLicensesWithoutWBSE.length,
      activeLicensesWithoutContractID: activeLicensesWithoutContractID.length,
      licensesWithNotes: licensesWithNotes.length,
      activeLicensesWithoutWBSEData: activeLicensesWithoutWBSE,
      activeLicensesWithoutContractIDData: activeLicensesWithoutContractID
    };
  }, [licenseData]);

  const formatDate = () => {
    const now = new Date();
    return now.toISOString().replace(/[:.]/g, "-");
  };

  const onload = () => {
    const idToken = localStorage.getItem("token");
    setgenwiz({
      appName: 'gwLoading',
      config: {
        stateFunction: setgenwiz,
        text: 'Fetching Data',
      }
    });
    axios.get("https://api-cam.mywizard-aiops.com/dashboard/splunk-license/read/all", {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    }).then((response) => {
      setLicenseData(response.data);
      setgenwiz({});
      setisloading(false);
    }).catch((error) => {
      console.error("Error fetching license data:", error);
      setgenwiz({});
      setisloading(false);
    });
  };

  useEffect(() => {
    onload();
    setisloading(true);
  }, []);

  // Download function for ACTIVE licenses without WBSE
  const downloadActiveLicensesWithoutWBSE = () => {
    setgenwiz({
      appName: 'gwAlert',
      config: {
        stateFunction: setgenwiz,
        text: 'Downloading Active Licenses without WBSE',
      }
    });
  };

  // Download function for ACTIVE licenses without Contract ID
  const downloadActiveLicensesWithoutContractID = () => {
    setgenwiz({
      appName: 'gwAlert',
      config: {
        stateFunction: setgenwiz,
        text: 'Downloading Active Licenses without Contract ID',
      }
    });
  };

  const hideTMenu = () => {
    const alldiv = document.getElementsByClassName('table-menu');
    for (var i = 0, len = alldiv.length; i < len; i++) {
      alldiv[i].style["display"] = 'none';
    }
  };

  const tableButton = (evt) => {
    evt.stopPropagation();
    const curdiv = evt.target.closest("td").querySelector(".table-menu");
    if (curdiv.style.display === "block") {
      curdiv.style.display = "none";
    } else {
      const alldiv = document.getElementsByClassName("table-menu");
      for (let i = 0; i < alldiv.length; i++) alldiv[i].style.display = "none";
      curdiv.style.display = "block";
    }
  };

  const handleSendMail = (license) => {
    hideTMenu();
    setSelectedLicense(license);
    setOrderId(license.sap_contract_id || "");
    setSendMailVisible(true);
  };

  const handleLicenseCancel = (license) => {
    hideTMenu();
    setSelectedLicense(license);
    setCancelStatus(license.status || "Active");
    setCancelVisible(true);
  };

  const toggleLicense = (licenseStatus, Notes) => {
    const idToken = localStorage.getItem("token");
    const postData = {
      "ID": selectedLicense.id,
      "Status": licenseStatus,
      "Notes": Notes,
    }
    const urloptions = {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    };
    const urlparams = new URLSearchParams(postData).toString();
    const url = `https://api-cam.mywizard-aiops.com/dashboard/splunk-license/update/status?` + urlparams;
    axios.post(
      url, postData, urloptions
    ).then((resp) => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Database Updated',
          callback: () => {
            onload();
          }
        }
      });
    }).catch((err) => {
      console.log(err)
    });
  }

  const sendMail = async () => {
    const mainEmail = selectedLicense.user_email.trim() || "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!mainEmail) {
      alert("Recipient email is required.");
      return;
    }
    if (!emailRegex.test(mainEmail)) {
      alert("Recipient email is invalid.");
      return;
    }

    const ccEmails = additionalCc
      .split(",")
      .map(email => email.trim())
      .filter(email => email.length > 0);

    const invalidCc = ccEmails.find(email => !emailRegex.test(email));
    if (invalidCc) {
      alert(`Invalid CC email: ${invalidCc}`);
      return;
    }
    const idToken = localStorage.getItem("token");
    const datalist = {
      id: selectedLicense.id,
      cc: additionalCc,
      emailto: mainEmail
    };
    const urloptions = {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    };

    const urlparams = new URLSearchParams(datalist).toString();
    const url = `https://api-cam.mywizard-aiops.com/dashboard/splunk-license/resend/email/?` + urlparams;

    setSendMailVisible(false);

    axios.post(
      url, datalist, urloptions
    ).then((resp) => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Mail sent successfully!',
        }
      });
    }).catch(() => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Failed to send mail',
        }
      });
    });
  }

  const editData = () => {
    const licenseId = selectedLicense && selectedLicense.id;
    const idToken = localStorage.getItem("token");
    const url = `https://api-cam.mywizard-aiops.com/dashboard/splunk-license/update/${licenseId}`;
    const payload = {
      id: licenseId,
      fields: editFields
    };
    const urloptions = {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    };
    setEditVisible(false);
    axios.post(
      url, payload, urloptions
    ).then((resp) => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'License updated successfully!',
          callback: () => {
            onload();
          }
        }
      });
    }).catch(() => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Failed to update license.',
        }
      });
    });
  }

  const inactivateLicense = (license) => {
    setSelectedLicense(license);
    hideTMenu();
    setgenwiz({
      appName: 'gwConfirm',
      config: {
        stateFunction: setgenwiz,
        text: 'Deactivate the License?',
        onloop: true,
        bntYes: () => {
          setgenwiz({
            appName: 'gwInput',
            config: {
              height: 'auto',
              stateFunction: setgenwiz,
              text: 'User Notes',
              type: 'textarea',
              bntSubmit: async (data) => {
                toggleLicense("inactive", data)
              }
            },
          });
        }
      },
    });
  };

  const activateLicense = (license) => {
    setSelectedLicense(license);
    hideTMenu();
    setgenwiz({
      appName: 'gwConfirm',
      config: {
        stateFunction: setgenwiz,
        text: 'Activate the License?',
        onloop: true,
        bntYes: () => {
          setgenwiz({
            appName: 'gwInput',
            config: {
              height: 'auto',
              stateFunction: setgenwiz,
              text: 'User Notes',
              type: 'textarea',
              bntSubmit: async (data) => {
                toggleLicense("active", data)
              }
            },
          });
        }
      },
    });
  };

  const handleEdit = (license) => {
    hideTMenu();
    setSelectedLicense(license);
    setEditFields({
      customer_name: license.customer_name || "",
      sap_contract_id: license.sap_contract_id || "",
      tenant_type: license.tenant_type || "",
      user_email: license.user_email || "",
      wbse_code: license.wbse_code || ""
    });
    setEditVisible(true);
  };

  const handleDelete = (license) => {
    hideTMenu();
    setSelectedLicense(license);
    setDeleteVisible(true);
  };

  const handleDetailsClick = (license) => {
    hideTMenu();
    setSelectedLicense(license);
    setPopupVisible(true);
  };

  const handleClosePopup = () => {
    setPopupVisible(false);
    setSelectedLicense(null);
  };

  const filteredLicenses = licenseData
    .filter((license) => {
      const query = searchQuery.toLowerCase();
      return (
        license.id.toString().includes(query) ||
        (license.customer_name && license.customer_name.toLowerCase().includes(query)) ||
        (license.sap_contract_id && license.sap_contract_id.toLowerCase().includes(query)) ||
        (license.user_email && license.user_email.toLowerCase().includes(query)) ||
        (license.wbse_code && license.wbse_code.toLowerCase().includes(query)) ||
        (license.status && license.status.toLowerCase().includes(query)) ||
        (license.tenant_type && license.tenant_type.toLowerCase().includes(query)) ||
        (license.environment && license.environment.toLowerCase().includes(query)) ||
        (license.licence_capacity_gb && license.licence_capacity_gb.toString().includes(query)) ||
        (license.licence_order_id && license.licence_order_id.toLowerCase().includes(query)) ||
        (license.date_created && license.date_created.includes(query)) ||
        (license.licence_date_expires && license.licence_date_expires.includes(query)) ||
        (license.notes && license.notes.toLowerCase().includes(query))
      );
    })
    .sort(function (a, b) {
      switch (currentSortField) {
        case 'customer_name':
          const nameA = (a.customer_name && a.customer_name.toLowerCase()) || "";
          const nameB = (b.customer_name && b.customer_name.toLowerCase()) || "";
          if (nameA < nameB) return sortByCustomerNameAsc ? -1 : 1;
          if (nameA > nameB) return sortByCustomerNameAsc ? 1 : -1;
          return 0;

        case 'license_poc':
          const pocA = (a.user_email && a.user_email.toLowerCase()) || "";
          const pocB = (b.user_email && b.user_email.toLowerCase()) || "";
          if (pocA < pocB) return sortByLicensePoCasc ? -1 : 1;
          if (pocA > pocB) return sortByLicensePoCasc ? 1 : -1;
          return 0;

        case 'capacity':
          const capacityA = parseInt(a.licence_capacity_gb) || 0;
          const capacityB = parseInt(b.licence_capacity_gb) || 0;
          return sortByCapacityAsc ? capacityA - capacityB : capacityB - capacityA;

        default:
          return 0;
      }
    });

  const csvHeaders = [
    { label: "Customer Name", key: "customer_name" },
    { label: "License PoC", key: "user_email" },
    { label: "Contract ID", key: "sap_contract_id" },
    { label: "Initial Request Date", key: "date_created" },
    { label: "Capacity", key: "licence_capacity_gb" },
    { label: "Date Expires", key: "licence_date_expires" },
    { label: "WBSE", key: "wbse_code" },
    { label: "Environment", key: "environment" },
    { label: "Dynamo DB ID", key: "id" },
    { label: "License Renewal Date", key: "licence_date_created" },
    { label: "License Expiry Date", key: "licence_date_expires" },
    { label: "License Order ID", key: "licence_order_id" },
    { label: "Tenant Type", key: "tenant_type" },
    { label: "License Status", key: "status" },
    { label: "User Notes", key: "notes" }
  ];

  const totalPages = Math.ceil(filteredLicenses.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedLicenses = filteredLicenses.slice(startIndex, endIndex);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", alignItems: 'center', padding: "0px 10px", position: 'relative' }}>
        <StyledSearchBarPlatforms
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          id="outlined-search"
          type="search"
          margin="normal"
          placeholder="Search filter"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <StyledSearchIcon />
              </InputAdornment>
            ),
          }}
          style={{ borderRadius: '30px' }}
        />
        <div style={{ position: 'absolute', top: '25px', right: '-15px', padding: "5px 20px", height: "40px" }}>
          <CSVLink
            headers={csvHeaders}
            data={filteredLicenses}
            filename={`SplunkLicenseExport_${formatDate()}.csv`}
            onClick={() => {
              setgenwiz({
                appName: 'gwAlert',
                config: {
                  stateFunction: setgenwiz,
                  text: 'Downloading License Data',
                }
              })
            }}
            style={{
              padding: "8px", backgroundColor: "#7500C0", color: "#fff", textDecoration: "none", borderRadius: "4px",
            }}
          >
            Download CSV
          </CSVLink>
        </div>
      </div>
      {/* Enhanced License Usage Statistics Dashboard */}
      <div style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        padding: "20px 10px", 
        backgroundColor: "#f5f5f5", 
        borderRadius: "8px", 
        margin: "10px 0",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
      }}>
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", justifyContent: "center" }}>
          <div style={{ textAlign: "center", padding: "10px 15px" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#7500C0" }}>
              {licenseStats.totalLicenses}
            </div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
              Total Licenses
            </div>
          </div>
          
          <div style={{ textAlign: "center", padding: "10px 15px" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#28a745" }}>
              {licenseStats.activeLicenses}
            </div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
              Active Licenses
            </div>
          </div>
          
          <div style={{ textAlign: "center", padding: "10px 15px" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#dc3545" }}>
              {licenseStats.inactiveLicenses}
            </div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
              Deactive Licenses
            </div>
          </div>
          
          <div style={{ textAlign: "center", padding: "10px 15px" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#17a2b8" }}>
              {licenseStats.totalCapacityActive} GB
            </div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
              Active Capacity
            </div>
          </div>
          
          <div style={{ textAlign: "center", padding: "10px 15px" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#ffc107" }}>
              {licenseStats.activePercentage}%
            </div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
              Active Rate
            </div>
          </div>

          {/* Active Licenses Missing WBSE */}
          <div style={{ textAlign: "center", padding: "10px 15px", cursor: "pointer" }}
               onClick={() => downloadActiveLicensesWithoutWBSE()}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#e74c3c" }}>
              {licenseStats.activeLicensesWithoutWBSE}
            </div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
              Active Missing WBSE
            </div>
            <CSVLink
              headers={csvHeaders}
              data={licenseStats.activeLicensesWithoutWBSEData}
              filename={`Active_Licenses_Without_WBSE_${formatDate()}.csv`}
              style={{ fontSize: "10px", color: "#007bff", textDecoration: "underline" }}
            >
              Download
            </CSVLink>
          </div>

          {/* Active Licenses Missing Contract ID */}
          <div style={{ textAlign: "center", padding: "10px 15px", cursor: "pointer" }}
               onClick={() => downloadActiveLicensesWithoutContractID()}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#e67e22" }}>
              {licenseStats.activeLicensesWithoutContractID}
            </div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
              Active Missing Contract ID
            </div>
            <CSVLink
              headers={csvHeaders}
              data={licenseStats.activeLicensesWithoutContractIDData}
              filename={`Active_Licenses_Without_ContractID_${formatDate()}.csv`}
              style={{ fontSize: "10px", color: "#007bff", textDecoration: "underline" }}
            >
              Download
            </CSVLink>
          </div>

          <div style={{ textAlign: "center", padding: "10px 15px" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#9b59b6" }}>
              {licenseStats.licensesWithNotes}
            </div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
              With Notes
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced License Table with Text Wrapping */}
      <table className="licensedata">
        <thead>
          <tr>
            <th
              style={{ cursor: "pointer", textDecoration: currentSortField === 'customer_name' ? "underline" : "none" }}
              onClick={() => {
                setSortByCustomerNameAsc(!sortByCustomerNameAsc);
                setCurrentSortField('customer_name');
              }}
            >
              Customer Name {currentSortField === 'customer_name' && (sortByCustomerNameAsc ? '↑' : '↓')}
            </th>
            <th
              style={{ 
                cursor: "pointer", 
                textDecoration: currentSortField === 'license_poc' ? "underline" : "none",
                minWidth: "200px"
              }}
              onClick={() => {
                setSortByLicensePoCasc(!sortByLicensePoCasc);
                setCurrentSortField('license_poc');
              }}
            >
              License PoC {currentSortField === 'license_poc' && (sortByLicensePoCasc ? '↑' : '↓')}
            </th>
            <th>Contract ID</th>
            <th>Initial Request Date</th>
            <th
              style={{ cursor: "pointer", textDecoration: currentSortField === 'capacity' ? "underline" : "none" }}
              onClick={() => {
                setSortByCapacityAsc(!sortByCapacityAsc);
                setCurrentSortField('capacity');
              }}
            >
              Capacity {currentSortField === 'capacity' && (sortByCapacityAsc ? '↑' : '↓')}
            </th>
            <th>Date Expires</th>
            <th>WBSE</th>
            <th>License Status</th>
            <th style={{ minWidth: "150px" }}>Notes</th>
            <th style={{ width: "100px" }}>Action</th>
          </tr>
        </thead>
        <tbody className={isloading && 'skeleton'}>
          {isloading ? (
            Array.from({ length: 10 }).map((_, i) => (
              <tr key={i}>
                {Array.from({ length: 10 }).map((_, j) => (
                  <td key={j}><span>0000000000</span></td>
                ))}
              </tr>
            ))
          ) : (
            paginatedLicenses.map((license, index) => (
              <tr key={index}>
                <td>{license.customer_name}</td>
                <td style={{ 
                  maxWidth: "200px", 
                  wordWrap: "break-word", 
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  lineHeight: "1.4"
                }}>
                  {license.user_email}
                </td>
                <td style={{ color: (!license.sap_contract_id || license.sap_contract_id.trim() === '') ? '#dc3545' : 'inherit' }}>
                  {license.sap_contract_id || 'Missing'}
                </td>
                <td>{license.date_created.replace(/[TZ]/g, '')}</td>
                <td>{license.licence_capacity_gb}GB</td>
                <td>{license.licence_date_expires.replace(/[TZ]/g, '')}</td>
                <td style={{ color: (!license.wbse_code || license.wbse_code.trim() === '') ? '#dc3545' : 'inherit' }}>
                  {license.wbse_code || 'Missing'}
                </td>
                <td>
                  <span style={{
                    padding: "4px 8px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    backgroundColor: license.status.toLowerCase() === 'active' ? '#d4edda' : '#f8d7da',
                    color: license.status.toLowerCase() === 'active' ? '#155724' : '#721c24'
                  }}>
                    {license.status}
                  </span>
                </td>
                <td style={{ 
                  maxWidth: "150px", 
                  wordWrap: "break-word", 
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  fontSize: "12px",
                  lineHeight: "1.3"
                }}>
                  {license.notes ? (
                    <div title={license.notes}>
                      {license.notes.length > 50 
                        ? `${license.notes.substring(0, 50)}...` 
                        : license.notes}
                    </div>
                  ) : (
                    <span style={{ color: '#6c757d', fontStyle: 'italic' }}>No notes</span>
                  )}
                </td>
                <td style={{ position: 'relative' }}>
                  <button type="button" onClick={(evt) => tableButton(evt)}></button>
                  <div className="table-menu" style={{ display: "none" }}>
                    <div className="tri"></div>
                    <ul>
                      <li onClick={() => handleDetailsClick(license)}>Details</li>
                      <li onClick={() => handleEdit(license)}>Edit</li>
                      <li onClick={() => handleSendMail(license)}>Send Mail</li>
                    </ul>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* All existing modals remain the same */}
      {popupVisible && selectedLicense && (
        <CommonDialogV2
          open={popupVisible}
          onClose={handleClosePopup}
          width='480px'
          title={<div>License Details</div>}
          textContent={
            <div style={{ padding: "15px 5px" }}>
              <table style={{ width: '100%' }}>
                <tbody>
                  {[
                    { label: "Dynamo DB", value: selectedLicense.licence_id },
                    { label: "Customer", value: selectedLicense.customer_name },
                    { label: "Environment", value: selectedLicense.environment },
                    { label: "Contract ID", value: selectedLicense.sap_contract_id },
                    { label: "Order ID", value: selectedLicense.licence_order_id },
                    { label: "Renewal Date", value: selectedLicense.licence_date_created.replace(/[TZ]/g, '') },
                    { label: "Expiry Date", value: selectedLicense.licence_date_expires.replace(/[TZ]/g, '') },
                    { label: "License ID", value: selectedLicense.licence_id },
                    { label: "Capacity", value: selectedLicense.licence_capacity_gb + 'GB' },
                    { label: "Tenant Type", value: selectedLicense.tenant_type },
                    { label: "PoC", value: selectedLicense.user_email },
                    { label: "WBSE", value: selectedLicense.wbse_code },
                    { label: "Notes", value: selectedLicense.notes },
                  ].map((item, idx) => (
                    <tr key={idx} style={{ padding: '10px 5px', fontSize: "15px" }}>
                      <td style={{ fontWeight: "600", width: '140px' }}>{item.label}:</td>
                      <td style={{ 
                        width: 'auto', 
                        wordWrap: "break-word", 
                        wordBreak: "break-word",
                        whiteSpace: "normal"
                      }}>
                        {item.value || "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          }
          dialogActions={
            <DialogActions style={{ padding: "8px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button
                onClick={() => { handleClosePopup(); handleEdit(selectedLicense) }}
                style={{
                  padding: "8px 16px", backgroundColor: "blueviolet", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer", width: '100px'
                }}
              >
                Edit
              </button>
              <button
                onClick={() => {
                  handleClosePopup();
                  if (selectedLicense.status.toLowerCase() === 'active')
                    inactivateLicense(selectedLicense)
                  else
                    activateLicense(selectedLicense)
                }}
                style={{
                  padding: "8px 16px", backgroundColor: "blueviolet", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer", width: '100px'
                }}
              >
                {selectedLicense.status.toLowerCase() === 'active' ? "Deactivate" : "Activate"}
              </button>
              <button
                onClick={handleClosePopup}
                style={{
                  padding: "8px 16px", backgroundColor: "blueviolet", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer", width: '100px'
                }}
              >
                Close
              </button>
            </DialogActions>
          }
        />
      )}

      <CommonDialogV2
        open={isSendMailVisible}
        onClose={() => setSendMailVisible(false)}
        title={"Send Mail"}
        textContent={
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <label><strong>Additional CC:</strong></label>
            <input
              type="email"
              value={additionalCc}
              onChange={(e) => setAdditionalCc(e.target.value)}
              placeholder="e.g. user1@accenture.com, user2@example.com"
              style={{ width: "95%", padding: "10px", marginTop: "6px" }}
            />
            <small style={{ color: "#666", fontSize: "12px", marginTop: "4px", display: "block" }}>
              Multiple emails separated with commas.
            </small>
          </div>
        }
        dialogActions={
          <DialogActions>
            <button
              onClick={() => sendMail()}
              style={{
                width: '80px', padding: "8px", backgroundColor: "#7500C0", color: "#fff", border: "none", borderRadius: "4px", marginRight: "5px"
              }}
            >
              Send Mail
            </button>
            <button
              onClick={() => setSendMailVisible(false)}
              style={{
                width: '80px', padding: "8px", backgroundColor: "#7500C0", color: "#fff", border: "none", borderRadius: "4px", marginRight: "15px"
              }}
            >
              Close
            </button>
          </DialogActions>
        }
      />

      <CommonDialogV2
        open={isEditVisible}
        onClose={() => setEditVisible(false)}
        title={"Edit License"}
        width="420px"
        textContent={
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {Object.entries(editFields).map(([key, value]) => {
              let label = key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
              if (key === "sap_contract_id") label = "Contract ID";
              if (key === "user_email") label = "License PoC";
              if (key === "wbse_code") label = "WBSE";

              return (
                <div key={key}>
                  <label style={{ fontWeight: '500' }}>{label}</label>
                  <input
                    type="text"
                    value={value}
                    onChange={(e) =>
                      setEditFields({ ...editFields, [key]: e.target.value })
                    }
                    placeholder={
                      key === "user_email"
                        ? "e.g. user1@accenture.com, user2@example.com"
                        : `Enter ${label}`
                    }
                    style={{
                      width: "95%", padding: "10px", marginTop: "6px", border: '1px solid #E5E5E5', borderRadius: '3px'
                    }}
                  />
                  {key === "user_email" && (
                    <small
                      style={{
                        color: "#666", fontSize: "12px", marginTop: "4px", display: "block"
                      }}
                    >
                      Multiple emails separated with commas.
                    </small>
                  )}
                </div>
              );
            })}
          </div>
        }
        dialogActions={
          <DialogActions>
            <button
              onClick={() => editData()}
              style={{
                width: '80px', padding: "8px 16px", backgroundColor: "#7500C0", color: "#fff", border: "none", borderRadius: "4px", marginRight: "8px"
              }}
            >
              Save
            </button>
            <button
              onClick={() => setEditVisible(false)}
              style={{
                width: '80px', padding: "8px 16px", backgroundColor: "#7500C0", color: "#fff", border: "none", borderRadius: "4px"
              }}
            >
              Cancel
            </button>
          </DialogActions>
        }
      />

      <GenWiz open={true} appconfig={gwconfig} />

      {totalPages > 1 &&
        <div style={{ display: "flex", justifyContent: "flex-end", margin: "20px 30px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                padding: "6px 12px", backgroundColor: "#7500C0", color: "#fff", border: "none", borderRadius: "4px", cursor: currentPage === 1 ? "not-allowed" : "pointer"
              }}
            >
              Prev
            </button>
            <span style={{ margin: "0 8px" }}>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              style={{
                padding: "6px 12px", backgroundColor: "#7500C0", color: "#fff", border: "none", borderRadius: "4px",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer"
              }}
            >
              Next
            </button>
          </div>
        </div>
      }
    </>
  );
};

export default LicenseManagement;
